import { jwtDecode } from 'jwt-decode';
import { JWTUser } from './state';

export function decodeAPITokenJWT(token: string | null): JWTUser | null {
  if (!token) {
    return null;
  }

  try {
    return jwtDecode<JWTUser>(token);
  } catch (error) {
    console.log(error);
    return null;
  }
}
